<template>
      <v-layout row wrap justify-center align-center>
          <v-flex xs12>
            <v-expansion-panel>
              <v-expansion-panel-content>
                <div slot="header"> 
                  Detalhes da turma {{ turmaData.name  }}
                  <v-icon
                    v-if="!isMakerlab"
                    size="25"
                    @click="urlCalendar" 
                    style="margin-left: 25px"
                  >
                    calendar_today
                  </v-icon>
                </div>
                <v-card class='mb-2'>
                  <v-card-title class="ml-4">
                    <v-flex xs10 justify-center align-center class='text-xs-center'> 
                        <h1>{{ turmaData.name }}</h1>
                    </v-flex>
                    <v-flex xs2 v-if="editing">
                      <v-icon
                        size="25"
                        @click="dialog = true"
                        style="float: right" 
                      >
                        delete
                      </v-icon>                      
                    </v-flex>
                    <v-flex xs12 justify-start>
                      <profile-text title="Nome :" v-model='turmaData.name'
                        :editing='editing'
                        :last='true'
                        @input.native="refreshString">
                      </profile-text>
                      <profile-text title="Descrição :" v-model='turmaData.description'
                        :editing='editing'
                        :last='true'
                        @input.native="refreshString"
                        input-type='multilinetext'>
                      </profile-text>
                    </v-flex>
                    <v-flex xs6 justify-start >
                      <profile-text v-if="!editing || isMakerlab"
                        title="Programa inscrito :" v-model='turmaData.programa'
                        :last='true'
                        input-type='multilinetext'></profile-text>
                      <div v-if="editing">
                        <h3 v-if="!isMakerlab">Programa : </h3>
                          <v-autocomplete
                            v-if="editing && !isMakerlab"
                            :items="programas"
                            v-model="turmaData.programa"
                            label="Escolha o programa"
                            item-text="name"
                            item-value="name"
                            chips
                            max-height="auto"
                            style="width: 94%"
                          > </v-autocomplete>
                      </div>
                      <profile-text title="Periocidade :" v-model='turmaData.tipo'
                        :last='true'
                        v-if="!isMakerlab"
                        input-type='multilinetext'></profile-text>
                      <profile-text v-if="turmaData.dia_semana !== '' "
                        title="Dia da semana :" v-model='turmaData.dia_semana'
                        :last='true'
                        input-type='text'></profile-text>
                    </v-flex>
                    <v-flex xs6 justify-start>
                      <profile-text title="Horário :" v-model='turmaData.horario'
                        :last='true'
                        v-if="!isMakerlab"
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Duração :" v-model='turmaData.duracao'
                        :last='true'
                        v-if="!isMakerlab"
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Data de início :" v-model='datainicio'
                        :last='true'
                        v-if="!isMakerlab"
                        input-type='multilinetext'></profile-text>
                      <profile-text title="Data do fim :" v-model='datafim'
                        :last='true'
                        v-if="!isMakerlab"
                        input-type='multilinetext'></profile-text>
                    </v-flex>
                    <v-flex xs6 justify-start>
                      <div style="height: 1rem"></div>
                      <p>
                        <strong style="font-size: 1.2rem">Unidade: </strong>
                        <v-chip label
                        desable 
                        color='amber'
                        outline>
                            {{unidades[0].name}}
                        </v-chip>
                      </p>
                      <p>
                        <strong style="font-size: 1.2rem">Alunos: </strong>
                        <v-chip 
                          v-if="!editing"
                          v-for="un 
                          in turmaData.alunos"
                          :key='un.nome'
                          desable 
                          color='blue'
                          outline>
                          <v-avatar>
                            <img :src="un.profilePic" alt="">
                          </v-avatar>
                              {{un.username}}
                        </v-chip>
                      </p>
                        <v-autocomplete
                          v-if="editing"
                          :items="alunosUnidade"
                          v-model="turmaData.alunos"
                          label="Adicionar aluno na turma"
                          item-text="username"
                          item-value="username"
                          chips
                          multiple
                          max-height="auto"
                        > </v-autocomplete>
                      
                    </v-flex>
                    <v-flex xs6>
                      <p v-if="!editing">
                      <strong style="font-size: 1.2rem">Ano: </strong>
                        <v-chip label
                        desable 
                        color='primary'
                        outline>
                            {{turmaData.ano}}
                        </v-chip>
                      </p>
                      <v-autocomplete
                        v-if="editing"
                        label="Ano"
                        :items="ano"
                        item-text="name"
                        item-value="slug"
                        v-model="turmaData.ano"
                        max-height="400"
                        hint="Escolha o(s) ano(s)"
                        persistent-hint
                        ></v-autocomplete>
                      </v-flex> 
                      
                  </v-card-title>
                    <v-btn
                      v-if="this.$store.state.selectedRole.name === 'Admin'|| permissao"
                      absolute
                      dark
                      fab
                      bottom
                      right
                      color="blue"
                      @click="pressFloatingButton()"
                      >
                      <v-icon v-if='!editing'>mode_edit</v-icon>
                      <v-icon v-else>done</v-icon>
                    </v-btn>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>     
          </v-flex>
          <v-spacer></v-spacer>
          <v-container grid-list-md fluid>
            <v-layout align-start  row fill-height wrap>
              <v-flex  v-for="projeto in selecturma" :key="projeto.id" xs6 sm6 md6 xl6 lg6 wrap>
                <v-card hover width="100%" @click="gotoproject(projeto.id)"  >
                  <v-card-title > 
                    <v-layout row @click="gotoproject(projeto.id)">
                    <img :src="projeto.image" 
                      class="rounded-corner" 
                      style="margin-left: 2rem" 
                      width="70" height="70"  
                      @click="gotoproject(projeto.id)">
                    <h3 
                      style="margin-left: 0.8rem; font-size: 1.3rem" 
                      @click="gotoproject(projeto.id)">
                      {{ projeto.name }}
                    </h3>
                    </v-layout>
                  </v-card-title>
                  <v-card-text @click="gotoproject(projeto.id)">
                    <h3>Mediador : </h3> 
                    <v-chip 
                      desable 
                      color='blue'
                      outline>
                        {{projeto.moderador}}
                    </v-chip>
                    </v-card-text> 
                  <v-card-text style="margin-top: -20px">
                    <h3>Alunos:</h3> 
                    <div>
                      <v-chip 
                        v-for="al
                        in projeto.integrantes"
                        :key='al.aluno'
                        desable 
                        @click="goToStudent(al.username)"
                        color='blue'
                        v-if="al.status !== 'Saiu'"
                        outline>
                        <v-avatar >
                          <img :src="al.profilePic" alt="">
                        </v-avatar>
                            {{al.username}}
                      </v-chip>
                    </div>
                    <div></div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
            <!-- <v-flex xs12 justify-center class="text-xs-center">
              <v-pagination  
              :length="evidencias.pages" 
              total-visible="7"
              circle
              v-model="page"
              ></v-pagination>
            </v-flex> -->
            <v-dialog v-model="dialog" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">Deseja deletar?</v-card-title>
                <v-card-text>Gostaria excluir essa turma?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" flat @click.native="dialog = false">Cancelar</v-btn>
                  <v-btn color="green darken-1" flat @click.native="excluir()">Deletar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
  
      </v-layout>
</template>

<script>

import api from '@/api'
import ProfileText from '@/components/reusable/ProfileText.vue'
import AvalDialogContent from '@/components/reusable/AvalDialogContent.vue'
export default {
  components: {
    ProfileText,
    AvalDialogContent
  },
  data () {
    return {
      turmaData: {
        unidade: [],
        possiveisalunos: [],
        programa: '',
        alunos: [],
        dia_semana: '',
        tipo: '',
        name: '',
        ano: [],
        duracao: '',
        slug: '',
        description: '',
        horario: '',
        dt_inicio: '',
        dt_fim: ''
      },
      currentTab: 'Sobre',
      panel: [],
      addalunoturma: null,
      dialog: false,
      excluialunoturma: null,
      showImageUpload: false,
      imageChangeModal: false,
      unidades: [],
      alunosUnidade: [],
      editing: false,
      avaliando: false,
      evid_avaliada: {},
      selecturma: [],
      tempData: {},
      datainicio: '',
      datafim: '',
      options: {},
      criterios: {},
      payload: [],
      ano: {},
      avaliacoes: [],
      search: '',
      waiting: false,
      page: 1
    }
  },
  mounted () {
    var slugid = this.$route.params.slug
    api.request('GET', 'turmas/' + slugid + '/').then(response => {
      this.turmaData = response.data
      console.log('turma', response.data)
      this.tempData = _.cloneDeep(this.turmaData)
      this.datainicio = this.formatDate(this.turmaData.dt_inicio)
      this.datafim = this.formatDate2(this.turmaData.dt_fim)
      api.request('GET', 'unidade/').then(resp => {
        this.unidades = resp.data.filter(e => e.slug === this.turmaData.unidade)
      })
    }).then(resp => {
      api.request('GET', 'projetos/?turma=' + this.turmaData.id).then(resp => {
        this.selecturma = resp.data
      }).then(resp => {
        api.request('GET', 'users/?unidade__slug=' + this.turmaData.unidade).then(resp => {
          this.alunosUnidade = resp.data.filter(value => {
            return (value.groups.some(el => el === 'Aluno'))
          })
        })
      })
    })
    api.request('GET', 'programas/').then(response => {
      this.programas = response.data
      // console.log(this.programas)
    })
    api.request('GET', 'ano/').then(resp => {
      resp.data.sort((a, b) => (a.order_number > b.order_number) ? 1 : ((b.order_number > a.order_number) ? -1 : 0))
      this.ano = resp.data
    })
    this.$watch('turmaData.alunos', function () {
      this.addaluno()
    })
  },
  watch: {
  },
  computed: {
    filtroaluno () {
      var nomes = this.turmaData.alunos_unidade.filter(valor => {
        return valor.username
      })
      return nomes
    },
    permissao () {
      if (this.$store.state.user.is_superuser) {
        return true
      }
      if (this.$store.state.selectedRole.name === 'Mediador') {
        return false
      }
      if (this.$store.state.details.can_delete_turma) {
        return true
      }
      return false
    },
    isMakerlab () {
      return this.$store.state.company.makerlab;
    }
  },
  methods: {
    goToUnidade (unidade) {
      this.$router.push('/unidade/' + unidade)
    },
    goToStudent (aluno) {
      this.$router.push('/usuarios/' + aluno)
    },
    refreshString () {
      this.turmaData.description = ''
    },
    urlCalendar () {
      this.$router.push('/calendario/turma/' + this.turmaData.id)
    },
    getUserImage (username) {
      var userarray = this.turmaData.integrantes.filter(value => {
        return value.username === username
      })
      if (userarray[0]) {
        return userarray[0].profilePic
      } else {
        return ''
      }
    },
    getUser (username) {
      var userarray = this.turmaData.integrantes.filter(value => {
        return value.username === username
      })
      return userarray[0]
    },
    pressFloatingButton () {
      if (this.editing) {
        this.performSave()
      } else {
        this.editing = !this.editing
      }
    },
    performSave () {
      var slugid = this.$route.params.slug
      let self = this
      // if (self.turmaData.description === '') {
      //   self.turmaData.description = ' '
      //   console.log('aqui')
      // }
      api
        .request('PATCH', 'turmas/' + slugid + '/', {
          'name': self.turmaData.name,
          'description': self.turmaData.description,
          'programa': self.turmaData.programa,
          'ano': self.turmaData.ano
        })
        .then(function (response) {
          self.refreshUI()
          // console.log(response)
        })
      self.editing = false
    },
    excluir () {
      api.request('PATCH', 'turmas/' + this.$route.params.slug + '/', {
        'name': this.turmaData.name + new Date().toISOString(),
        'description': this.turmaData.description,
        'programa': this.turmaData.programa,
        'ano': this.turmaData.ano
      }).then(data => {
        console.log('data', data)
        api.request('DELETE', 'turmas/' + data.data.slug + '/').then(resp => {
          this.$router.push('/turmas')
        })
      })
    },
    addaluno () {
      var nomes = this.tempData.alunos.map(user => {
        return user.username
      })
      if (nomes.length < this.turmaData.alunos.length) {
        var add = this.turmaData.alunos.filter(function (element, index, array) {
          if (nomes.indexOf(element) === -1) { return element }
        })
        this.payload = {
          aluno: add.toString(),
          turma: this.turmaData.slug
        }
        api.request('POST', 'matricula/', this.payload).then(resp => {
          var slugid = this.$route.params.slug
          api.request('GET', 'turmas/' + slugid + '/').then(response => {
            this.turmaData = response.data
            this.tempData = _.cloneDeep(this.turmaData)
          })
        })
      }
      if (nomes.length > this.turmaData.alunos.length) {
        let self = this
        var exclui = nomes.filter(function (element, index, array) {
          if (self.turmaData.alunos.indexOf(element) === -1) { return element }
        })
        this.payload = {
          aluno: exclui.toString(),
          turma: this.turmaData.slug
        }
        api.request('DELETE', 'matricula/', this.payload).then(resp => {
          var slugid = this.$route.params.slug
          api.request('GET', 'turmas/' + slugid + '/').then(response => {
            this.turmaData = response.data
            this.tempData = _.cloneDeep(this.turmaData)
          })
          console.log(resp)
        })
      }
    },
    excluialuno () {
      var payload = {
        aluno: this.excluialunoturma,
        turma: this.turmaData.slug
      }
      api.request('DELETE', 'matricula/', payload).then(resp => {
        this.refreshUI()
        console.log(resp)
      })
    },
    refreshUI () {
      var slugid = this.$route.params.slug
      api.request('GET', 'turmas/' + slugid + '/').then(response => {
        this.turmaData = response.data
        this.tempData = _.cloneDeep(this.turmaData)
        api.request('GET', 'projetos/?turma=' + this.turmaData.id).then(resp => {
          this.selecturma = resp.data
        })
      })
    },
    gotoproject (id) {
      this.$router.push(
        {name: 'projeto-detail',
          params: {'id': id}
        })
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDate2 (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    }
  }
}
</script>

<style lang="scss" scoped>


.rounded-corner{
  border-radius: 10px;
}

.my-cards {
  column-count: 2;
  column-gap: 1em;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Turmas/Detail.vue